import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 查询调拨单列表
export function queryAllocationOrder(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/allocationOrder/queryAllocationOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询仓库列表
export function listShopHouses(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新调拨单
export function updateAllocationOrder(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/allocationOrder/updateAllocationOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除调拨单
export function deleteAllocationOrder(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/allocationOrder/deleteAllocationOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核调拨单
export function auditAllocationOrder(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/allocationOrder/auditAllocationOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询单个仓库
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}